// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__o-oPR","content":"styles_content__3Fiz4","checkbox":"styles_checkbox__3Ob-M","checkboxLabel":"styles_checkboxLabel__DiXx7"};